import { store, Measurements } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { StoreMixin } from '../../utility/store-mixin';
import { BinIssueStateMixin } from './bin-issue-state-mixin';
import '../../common/bn-property';

class BinIssueStateThankYou extends StoreMixin(BinIssueStateMixin(LitEntity)) {
  constructor() {
    super();
    this._stateChanged(store.getState());
    this.dimension = Measurements.get('dimension');
    this.weight = Measurements.get('weight');
  }

  static get properties() {
    return {
      userEmail: { type: String, attribute: false },
      userHref: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [...super.styles, css`
      .center {
        text-align: center;
      }
      .reported-data {
        width: 80%;
        margin: auto;
        padding: 1em;
        background-color: var(--gray-40);
        border: 1px solid var(--gray-50);
      }
      .reported-data p {
        margin-top: 0;
        margin-bottom: 0;
      }
      bn-property {
        margin: .25em 0;
        white-space: normal;
      }
      h4 {
        margin-top: 1em;
      }
    `];
  }

  render() {
    return html`
      <h2>Thank you for providing feedback</h2>
      <p class="center">You may be contacted by an administrator at: ${this.userEmail}</p>
      <div class="reported-data">
        <h3>Reported Data</h3>
        ${renderIf(this.data.physicalIssue !== undefined, () => html`
          <bn-property stacked label="Is a Physical Issue">${this.data.physicalIssue ? 'Yes' : 'No'}</bn-property>
        `)}
        <bn-property stacked label="Comments">${this.data.comments}</bn-property>
        ${renderIf(this.data.correctedLevelDate, () => html`
          <h4>Corrected Level Data</h4>
          <p>
            <bn-property stacked label="Date">${this.data.correctedLevelDate}</bn-property>
            <bn-property stacked label="Feed Height">${this.dimension.html({ dimension: this.data.correctedLevelHeight })}</bn-property>
            <bn-property stacked label="Feed Weight">${this.weight.html({ weight: this.data.correctedLevelWeight })}</bn-property>
          </p>
        `)}
        ${renderIf(this.data.correctedDimensions, () => html`
          <h4>Corrected Measurement Data</h4>
          <p>
            <bn-property stacked label="Top Height">${this.dimension.html({ dimension: this.data.correctedDimensions.topHeight })}</bn-property>
            <bn-property stacked label="Body Height">${this.dimension.html({ dimension: this.data.correctedDimensions.bodyHeight })}</bn-property>
            <bn-property stacked label="Hopper Height">${this.dimension.html({ dimension: this.data.correctedDimensions.hopperHeight })}</bn-property>
            <bn-property stacked label="Ring Count">${this.data.correctedDimensions.ringCount}</bn-property>
            <bn-property stacked label="Diameter">${this.dimension.html({ dimension: this.data.correctedDimensions.diameter })}</bn-property>
          </p>
        `)}
      </div>

      <p class="center">You may now close this modal.</p>

      <lit-entity .href="${this.userHref}" @update="${this._onUserUpdate}"></lit-entity>
    `;
  }

  _onUserUpdate(e) {
    const { entity } = e.detail;
    if (!entity) {
      return;
    }

    this.userEmail = entity.properties.email;
  }

  _stateChanged({ currentUserHref }) {
    this.userHref = currentUserHref;
  }
}

window.customElements.define('bin-issue-state-thank-you', BinIssueStateThankYou);
